export default __webpack_public_path__ + "static/media/c7.04ca287b.png";